import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { App, Button, Tag, } from 'antd';
import { CheckCircleOutlined, RollbackOutlined, } from '@ant-design/icons';
import { txt } from 'libs/i18n';
import SpeakerAvatar from 'components/SpeakerAvatarField/SpeakerAvatar';
import { getDefaultSpeakerName } from 'screens/DashboardScreen/components/SpeakerModal/speaker-utils';
import SpeakerDetailTable from '../SpeakerDetailTable';
import styles from './style.module.less';
const VersionDetailPanel = ({ entry, isLatestVersion, onRestoreVersion }) => {
    const { modal } = App.useApp();
    if (entry === null) {
        return _jsx("div", { className: styles.panel });
    }
    const speakerData = Object.assign(Object.assign({}, entry.dataSnapshot), { neutralData: entry.dataSnapshot.neutral });
    const handleRestore = () => {
        void modal.confirm({
            title: txt('restoreThisVersion'),
            content: txt('restoreThisVersionWarning'),
            okText: txt('restoreThisVersion'),
            cancelText: txt('cancel'),
            onOk: async () => {
                await onRestoreVersion(entry);
            },
        });
    };
    const speakerName = getDefaultSpeakerName(speakerData);
    return (_jsxs("div", { className: styles.panel, children: [_jsxs("div", { className: styles.panelHeader, children: [_jsx(SpeakerAvatar, { size: 40, value: speakerData.neutralData.imageBase64 }), speakerName, isLatestVersion === true ? (_jsx(Tag, { color: "success", icon: _jsx(CheckCircleOutlined, {}), children: txt('currentVersion') })) : (_jsx(Button, { type: "primary", size: "small", icon: _jsx(RollbackOutlined, {}), onClick: handleRestore, children: txt('restoreThisVersion') }))] }), _jsx("p", { className: styles.description, children: isLatestVersion === true
                    ? txt('currentSpeakerVersionDescription')
                    : txt('speakerVersionDescription') }), _jsx("div", { className: styles.tableWrapper, children: _jsx(SpeakerDetailTable, { speakerData: speakerData }) })] }));
};
export default VersionDetailPanel;
